import React, { Component } from 'react';
import './LocalArea.css';
import Urls from '../urls/Urls';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class LocalArea extends Component{
	constructor(props){
		super(props);
		const{hide, getInsertedMenuItemsHandler, configuration}=props;
		this._configuration = configuration;
		if(!getInsertedMenuItemsHandler)throwNotProvided('getInsertedMenuItemsHandler');
		this._callbackHide = hide;
		//this.show = this.show.bind(this);
		this.closeCurrentConfigurator = this.closeCurrentConfigurator.bind(this);
		this._handleClickButtonBack = this._handleClickButtonBack.bind(this);
		this._iframeLoaded= this._iframeLoaded.bind(this);	
		this._nextIframeKey = this._nextIframeKey.bind(this);
		this._getInsertedMenuItemsHandler = getInsertedMenuItemsHandler;
		this.state = {iframes:null, visible:false};
		this._iframeCount =0;
	}
	componentDidMount(){
		
	}
	setVisible(value){
		this._insertedMenuItemsRemoveHandle?.dispose();
		this._insertedMenuItemsRemoveHandle = null;
		if(value){
			this._insertedMenuItemsRemoveHandle = this._getInsertedMenuItemsHandler().registerMenuItems([
					(<IconButton className="configurator-back-button" imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'} onClick={this._handleClickButtonBack} key={HashSource.next()}></IconButton>)
				]
			);
		}
		this.setState({visible:value});
	}
	_handleClickButtonBack(){
		this._callbackHide();
	}
	_iframeLoaded(e){
	}
	closeCurrentConfigurator(){
		this.setState({iframes:[]});
	}
	_nextIframeKey(){
		return `iframe_${(this._iframeCount++)}`;
	}
	render(){
		const path = window.location.pathname.substr(0, window.location.pathname.indexOf('index.html'));
		const url = path.length<1?null:window.location.origin+path+'localarea/index.html';
		const className="local-area"+(this.state.visible?" visible":"");
		return (<div className={className}>
			<div className="iframe-wrapper">
				<iframe src={url} className="iframe-localarea" key={this._nextIframeKey()} style={{height:'100%'}} onLoad={this._iframeLoaded}></iframe>
			</div>
		</div>);
	}
}
